"use strict";

var _classCallCheck = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/jaeger/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _HtmlLayersGroup = _interopRequireDefault(require("./HtmlLayersGroup"));

var _MeasurableNodesLayer = _interopRequireDefault(require("./MeasurableNodesLayer"));

var _NodesLayer = _interopRequireDefault(require("./NodesLayer"));

var _propsFactories = require("./props-factories");

var _SvgEdgesLayer = _interopRequireDefault(require("./SvgEdgesLayer"));

var _SvgLayersGroup = _interopRequireDefault(require("./SvgLayersGroup"));

var _types = require("./types");

var _utils = require("./utils");

var _MiniMap = _interopRequireDefault(require("../zoom/MiniMap"));

var _ZoomManager = _interopRequireWildcard(require("../zoom/ZoomManager"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var WRAPPER_STYLE_ZOOM = {
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  width: '100%'
};
var WRAPPER_STYLE = {
  position: 'relative'
};
var idCounter = 0;

var Digraph =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Digraph, _React$PureComponent);

  function Digraph(props) {
    var _this;

    _classCallCheck(this, Digraph);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Digraph).call(this, props));
    _this.renderUtils = void 0;
    _this.state = {
      edges: [],
      layoutEdges: null,
      layoutGraph: null,
      layoutPhase: _types.ELayoutPhase.NoData,
      layoutVertices: null,
      sizeVertices: null,
      vertices: [],
      zoomTransform: _ZoomManager.zoomIdentity
    };
    _this.baseId = "plexus--Digraph--".concat(idCounter++);
    _this.makeClassNameFactory = (0, _memoizeOne.default)(function (classNamePrefix) {
      return function (name) {
        return "".concat(classNamePrefix, " ").concat(classNamePrefix, "-Digraph--").concat(name);
      };
    });
    _this.rootRef = React.createRef();
    _this.zoomManager = null;

    _this.getGlobalId = function (name) {
      return "".concat(_this.baseId, "--").concat(name);
    };

    _this.getZoomTransform = function () {
      return _this.state.zoomTransform;
    };

    _this.setSizeVertices = function (senderKey, sizeVertices) {
      var _this$props = _this.props,
          edges = _this$props.edges,
          layoutManager = _this$props.layoutManager,
          expectedKey = _this$props.measurableNodesKey;

      if (senderKey !== expectedKey) {
        var values = "expected ".concat(JSON.stringify(expectedKey), ", recieved ").concat(JSON.stringify(senderKey));
        throw new Error("Key mismatch for measuring nodes; ".concat(values));
      }

      _this.setState({
        sizeVertices: sizeVertices
      });

      var _layoutManager$getLay = layoutManager.getLayout(edges, sizeVertices),
          layout = _layoutManager$getLay.layout;

      layout.then(_this.onLayoutDone);

      _this.setState({
        sizeVertices: sizeVertices,
        layoutPhase: _types.ELayoutPhase.CalcPositions
      }); // We can add support for drawing nodes in the correct position before we have edges
      // via the following (instead of the above)
      // const { positions, layout } = layoutManager.getLayout(edges, sizeVertices);
      // positions.then(this._onPositionsDone);

    };

    _this.onZoomUpdated = function (zoomTransform) {
      _this.setState({
        zoomTransform: zoomTransform
      });
    };

    _this.onLayoutDone = function (result) {
      if (result.isCancelled) {
        return;
      }

      var layoutEdges = result.edges,
          layoutGraph = result.graph,
          layoutVertices = result.vertices;

      _this.setState({
        layoutEdges: layoutEdges,
        layoutGraph: layoutGraph,
        layoutVertices: layoutVertices,
        layoutPhase: _types.ELayoutPhase.Done
      });

      if (_this.zoomManager) {
        _this.zoomManager.setContentSize(layoutGraph);
      }
    };

    var _edges = props.edges,
        vertices = props.vertices,
        zoomEnabled = props.zoom;

    if (Array.isArray(_edges) && _edges.length && Array.isArray(vertices) && vertices.length) {
      _this.state.layoutPhase = _types.ELayoutPhase.CalcSizes;
      _this.state.edges = _edges;
      _this.state.vertices = vertices;
    }

    if (zoomEnabled) {
      _this.zoomManager = new _ZoomManager.default(_this.onZoomUpdated);
    }

    _this.renderUtils = {
      getGlobalId: _this.getGlobalId,
      getZoomTransform: _this.getZoomTransform
    };
    return _this;
  }

  _createClass(Digraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var current = this.rootRef.current;

      if (current && this.zoomManager) {
        this.zoomManager.setElement(current);
      }
    }
  }, {
    key: "renderLayers",
    value: function renderLayers() {
      var _this2 = this;

      var _this$props2 = this.props,
          classNamePrefix = _this$props2.classNamePrefix,
          topLayers = _this$props2.layers;
      var getClassName = this.makeClassNameFactory(classNamePrefix || ''); // eslint-disable-next-line @typescript-eslint/no-unused-vars

      var _this$state = this.state,
          _ = _this$state.sizeVertices,
          partialGraphState = _objectWithoutProperties(_this$state, ["sizeVertices"]);

      var graphState = _objectSpread({}, partialGraphState, {
        renderUtils: this.renderUtils
      });

      var layoutPhase = graphState.layoutPhase;
      return topLayers.map(function (layer) {
        var layerType = layer.layerType,
            key = layer.key,
            setOnContainer = layer.setOnContainer;

        if (layer.layers) {
          if (layer.layerType === _types.ELayerType.Html) {
            return React.createElement(_HtmlLayersGroup.default, {
              key: key,
              graphState: graphState,
              layers: layer.layers,
              getClassName: getClassName,
              setOnContainer: setOnContainer,
              setSizeVertices: _this2.setSizeVertices
            });
          } // svg group layer, the if is for TypeScript


          if (layer.layerType === _types.ELayerType.Svg) {
            return React.createElement(_SvgLayersGroup.default, {
              key: key,
              getClassName: getClassName,
              defs: layer.defs,
              graphState: graphState,
              layers: layer.layers,
              setOnContainer: setOnContainer
            });
          }
        }

        if (layer.edges) {
          // edges standalone layer
          var defs = layer.defs,
              markerEndId = layer.markerEndId,
              markerStartId = layer.markerStartId,
              setOnEdge = layer.setOnEdge;
          return layoutPhase === _types.ELayoutPhase.Done ? React.createElement(_SvgEdgesLayer.default, {
            key: key,
            standalone: true,
            getClassName: getClassName,
            defs: defs,
            graphState: graphState,
            markerEndId: markerEndId,
            markerStartId: markerStartId,
            setOnContainer: setOnContainer,
            setOnEdge: setOnEdge
          }) : null;
        }

        if (layer.measurable) {
          // standalone measurable Nodes Layer
          var measureNode = layer.measureNode,
              _renderNode = layer.renderNode,
              setOnNode = layer.setOnNode;
          return React.createElement(_MeasurableNodesLayer.default, {
            key: key,
            standalone: true,
            getClassName: getClassName,
            graphState: graphState,
            layerType: layerType,
            measureNode: measureNode,
            renderNode: _renderNode,
            senderKey: key,
            setOnContainer: setOnContainer,
            setOnNode: setOnNode,
            setSizeVertices: _this2.setSizeVertices
          });
        }

        var renderNode = layer.renderNode;

        if (renderNode !== undefined) {
          return React.createElement(_NodesLayer.default, {
            key: key,
            standalone: true,
            getClassName: getClassName,
            graphState: graphState,
            layerType: layer.layerType,
            renderNode: renderNode,
            setOnContainer: setOnContainer,
            setOnNode: layer.setOnNode
          });
        }

        throw new Error('Unrecognized layer');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          classNamePrefix = _this$props3.classNamePrefix,
          minimapEnabled = _this$props3.minimap,
          minimapClassName = _this$props3.minimapClassName,
          setOnGraph = _this$props3.setOnGraph,
          style = _this$props3.style;
      var builtinStyle = this.zoomManager ? WRAPPER_STYLE_ZOOM : WRAPPER_STYLE;
      var rootProps = (0, _utils.assignMergeCss)({
        style: builtinStyle,
        className: "".concat(classNamePrefix, " ").concat(classNamePrefix, "-Digraph")
      }, {
        className: className,
        style: style
      }, (0, _utils.getProps)(setOnGraph, _objectSpread({}, this.state, {
        renderUtils: this.renderUtils
      })));
      return React.createElement("div", rootProps, React.createElement("div", {
        style: builtinStyle,
        ref: this.rootRef
      }, this.renderLayers()), minimapEnabled && this.zoomManager && React.createElement(_MiniMap.default, Object.assign({
        className: minimapClassName,
        classNamePrefix: classNamePrefix
      }, this.zoomManager.getProps())));
    }
  }]);

  return Digraph;
}(React.PureComponent);

exports.default = Digraph;
Digraph.propsFactories = {
  classNameIsSmall: _propsFactories.classNameIsSmall,
  scaleOpacity: _propsFactories.scaleProperty.opacity,
  scaleStrokeOpacity: _propsFactories.scaleProperty.strokeOpacity,
  scaleStrokeOpacityStrong: _propsFactories.scaleProperty.strokeOpacityStrong,
  scaleStrokeOpacityStrongest: _propsFactories.scaleProperty.strokeOpacityStrongest
};
Digraph.scaleProperty = _propsFactories.scaleProperty;
Digraph.defaultProps = {
  className: '',
  classNamePrefix: 'plexus',
  minimap: false,
  minimapClassName: '',
  zoom: false
};